<template>
  <!-- 首页菜单 -->
  <div class="menu-box" @click="toPage">
    <div :class="classType">
      <div class="icon"></div>
      <div class="name">{{ name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    name: String,
    classType: String,
  },

  methods: {
    /**
     *跳页
     */
    toPage() {
      //临时处理
      if (this.classType == "BasicResources") {
        this.$router.push({
          name: "ScenicSpotDetails",
        });
      } else {
        this.$router.push({
          name: this.classType,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-box {
  cursor: pointer;
  width: rpx(250);
  height: rpx(290);

  .BasicResources {
    position: relative;
    width: rpx(250);
    height: rpx(290);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../assets/image/menu/ic_menu_bg_1.png");
    .icon {
      position: absolute;
      top: rpx(50);
      left: 0;
      right: 0;
      margin: auto;
      width: rpx(45);
      height: rpx(45);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../assets/image/menu/ic_data_show.png");
    }
    .name {
      position: absolute;
      bottom: rpx(-5);
      margin: auto;
      left: rpx(48);
      font-size: rpx(25);
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 168px;
    }
    &:hover {
      background-image: url("../assets/image/menu/ic_menu_selected1.png");

      .name {
        color: #88e685;
      }
    }
  }
  .VideoMonitoring {
    position: relative;
    width: rpx(234);
    height: rpx(271);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../assets/image/menu/ic_menu_bg_2.png");
    .icon {
      position: absolute;
      top: rpx(44);
      left: 0;
      right: 0;
      margin: auto;
      width: rpx(45);
      height: rpx(45);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../assets/image/menu/ic_video.png");
    }
    .name {
      position: absolute;
      bottom: rpx(-5);
      margin: auto;
      left: rpx(43);
      font-size: rpx(25);
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 168px;
    }
    &:hover {
      background-image: url("../assets/image/menu/ic_menu_selected2.png");
      .name {
        color: #88e685;
      }
    }
  }

  .GeographicInfo {
    position: relative;
    width: rpx(234);
    height: rpx(271);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../assets/image/menu/ic_menu_bg_2.png");
    .icon {
      position: absolute;
      top: rpx(44);
      left: 0;
      right: 0;
      margin: auto;
      width: rpx(45);
      height: rpx(45);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../assets/image/menu/ic_map.png");
    }
    .name {
      position: absolute;
      bottom: rpx(-5);
      margin: auto;
      left: rpx(43);
      font-size: rpx(25);
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 168px;
    }
    &:hover {
      background-image: url("../assets/image/menu/ic_menu_selected2.png");
      .name {
        color: #88e685;
      }
    }
  }

  .CarMonitoring {
    position: relative;
    width: rpx(221);
    height: rpx(257);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../assets/image/menu/ic_menu_bg_3.png");
    .icon {
      position: absolute;
      top: rpx(44);
      left: 0;
      right: 0;
      margin: auto;
      width: rpx(45);
      height: rpx(45);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../assets/image/menu/ic_car.png");
    }
    .name {
      position: absolute;
      bottom: rpx(-5);
      margin: auto;
      left: rpx(48);
      font-size: rpx(25);
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 168px;
    }
    &:hover {
      background-image: url("../assets/image/menu/ic_menu_selected3.png");
      .name {
        color: #88e685;
      }
    }
  }

  .ScenicSpotDetails {
    position: relative;
    width: rpx(221);
    height: rpx(257);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../assets/image/menu/ic_menu_bg_3.png");
    .icon {
      position: absolute;
      top: rpx(44);
      left: 0;
      right: 0;
      margin: auto;
      width: rpx(45);
      height: rpx(45);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../assets/image/menu/ic_passenger_flow.png");
    }
    .name {
      position: absolute;
      bottom: rpx(-5);
      margin: auto;
      left: rpx(48);
      font-size: rpx(25);
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 168px;
    }
    &:hover {
      background-image: url("../assets/image/menu/ic_menu_selected3.png");
      .name {
        color: #88e685;
      }
    }
  }

  .TicketMonitoring {
    position: relative;
    width: rpx(193);
    height: rpx(226);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../assets/image/menu/ic_menu_bg_4.png");
    .icon {
      position: absolute;
      top: rpx(30);
      left: 0;
      right: 0;
      margin: auto;
      width: rpx(45);
      height: rpx(45);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../assets/image/menu/ic_ticket.png");
    }
    .name {
      position: absolute;
      bottom: rpx(-20);
      margin: auto;
      left: rpx(33);
      font-size: rpx(21);
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 168px;
    }
    &:hover {
      background-image: url("../assets/image/menu/ic_menu_selected4.png");
      .name {
        color: #88e685;
      }
    }
  }

  .AnalysisPublic {
    position: relative;
    width: rpx(193);
    height: rpx(226);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../assets/image/menu/ic_menu_bg_4.png");
    .icon {
      position: absolute;
      top: rpx(30);
      left: 0;
      right: 0;
      margin: auto;
      width: rpx(45);
      height: rpx(45);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../assets/image/menu/ic_epidemic.png");
    }
    .name {
      position: absolute;
      bottom: rpx(-20);
      margin: auto;
      left: rpx(33);
      font-size: rpx(21);
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 168px;
    }
    &:hover {
      background-image: url("../assets/image/menu/ic_menu_selected4.png");
      .name {
        color: #88e685;
      }
    }
  }
}
</style>